import React, { Component } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import ItemLineCardGroup from '@atlassian/jira-common-components-item-line-card/src/item-line-card-group-view.tsx';
import type { ProjectType } from '@atlassian/jira-common-constants/src/project-types.tsx';
import type { LinkedIssue } from './common/types/children-issues-type.tsx';
import IssueLineCard from './common/utils/issue-line-card/issue-line-card-view.tsx';

type IssueKey = string;

type Props = {
	issues: LinkedIssue[];
	isReorderEnabled: boolean;
	isInteractive: boolean;
	canAddIssueLinks?: boolean;
	projectType: ProjectType | null;
	groupId: string;
	onOrderChange?: (
		items: ReadonlyArray<LinkedIssue>,
		target: LinkedIssue,
		sourceIdx: number,
		destinationIdx: number,
		analyticsEvent: UIAnalyticsEvent,
	) => void;
	onDelete?: (groupId: string, issueKey: IssueKey) => void;
	onEditIssue?: (issue: LinkedIssue) => void;
};

// eslint-disable-next-line jira/react/no-class-components
export class IssueLineCardGroup extends Component<Props> {
	static defaultProps = {
		isReorderEnabled: false,
		isInteractive: true,
		projectType: null,
	};

	handleClick = (issue: LinkedIssue): void => {
		if (issue.issueLink !== null && issue.issueLink !== undefined && issue.issueLink !== '') {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.open(issue.issueLink, '_blank');
		}
	};

	render(): React.JSX.Element {
		const { issues, onOrderChange, groupId, isReorderEnabled, isInteractive, projectType } =
			this.props;
		return (
			<ItemLineCardGroup
				items={issues}
				onOrderChange={onOrderChange}
				groupId={groupId}
				isReorderEnabled={isReorderEnabled}
				isInteractive={isInteractive}
				onClick={this.handleClick}
			>
				{(isHovering, isActive, isFocused, issue) => (
					<IssueLineCard
						isHovering={isHovering}
						isActive={isActive}
						isFocused={isFocused}
						isDraggable={isReorderEnabled}
						isInteractive={isInteractive}
						issueId={issue.id}
						// @ts-expect-error - TS2783 - 'projectType' is specified more than once, so this usage will be overwritten.
						projectType={projectType}
						{...issue}
					/>
				)}
			</ItemLineCardGroup>
		);
	}
}
